window.addEventListener('load', () => {
  if (!window.gsap || !window.ScrollTrigger) {
    console.warn('[JabaGift] GSAP or ScrollTrigger not loaded — showing elements as fallback');
    document.querySelectorAll('[data-anim="fade-up"], [data-anim="stagger"] > *').forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  const isDesktop = window.innerWidth >= 1024;

  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ limitCallbacks: true, ignoreMobileResize: true });

  // Batch all trigger registrations to avoid layout thrashing
  ScrollTrigger.batch('[data-anim="fade-up"]', {
    onEnter: (elements) => {
      gsap.fromTo(elements,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out', stagger: 0.08, overwrite: true }
      );
    },
    start: 'top 88%',
    once: true,
  });

  // Stagger children
  gsap.utils.toArray('[data-anim="stagger"]').forEach((container) => {
    ScrollTrigger.batch(container.children, {
      onEnter: (elements) => {
        gsap.fromTo(elements,
          { y: 30, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.8, stagger: 0.1, ease: 'power3.out', overwrite: true }
        );
      },
      start: 'top 82%',
      once: true,
    });
  });

  // Image reveal
  gsap.utils.toArray('[data-anim="image-reveal"]').forEach((el) => {
    gsap.fromTo(el,
      { clipPath: 'inset(100% 0 0 0)' },
      {
        clipPath: 'inset(0% 0 0 0)',
        duration: 1.2,
        ease: 'power3.inOut',
        scrollTrigger: { trigger: el, start: 'top 78%', once: true },
      }
    );
  });

  // Sticky scroll storytelling (Atelier Difference) — IntersectionObserver, no GSAP overhead
  const stickySection = document.querySelector('[data-sticky-scroll]');
  if (stickySection) {
    const steps   = Array.from(stickySection.querySelectorAll('[data-step]'));
    const visuals = Array.from(stickySection.querySelectorAll('[data-visual]'));
    function activateStep(index) {
      steps.forEach((s, i)  => s.classList.toggle('is-active', i === index));
      visuals.forEach((v, i) => v.classList.toggle('is-active', i === index));
    }
    const stepObserver = new IntersectionObserver(
      (entries) => { entries.forEach(entry => { if (entry.isIntersecting) activateStep(steps.indexOf(entry.target)); }); },
      { threshold: 0, rootMargin: '-35% 0px -35% 0px' }
    );
    steps.forEach(step => stepObserver.observe(step));
    activateStep(0);
  }

  // Hero parallax — desktop only, lightweight
  if (isDesktop) {
    const heroContent = document.querySelector('.hero-atelier__content');
    if (heroContent) {
      gsap.to(heroContent, {
        yPercent: -12,
        opacity: 0.7,
        ease: 'none',
        scrollTrigger: {
          trigger: '.hero-atelier',
          start: 'top top',
          end: 'bottom top',
          scrub: 1.5,
          onEnter:     () => { heroContent.style.willChange = 'transform, opacity'; },
          onLeave:     () => { heroContent.style.willChange = 'auto'; },
          onEnterBack: () => { heroContent.style.willChange = 'transform, opacity'; },
          onLeaveBack: () => { heroContent.style.willChange = 'auto'; },
        },
      });
    }

    // Background parallax
    gsap.utils.toArray('[data-anim="parallax"]').forEach((el) => {
      const speed = parseFloat(el.dataset.parallaxSpeed) || 0.3;
      const img = el.querySelector('[data-parallax-target]') || el;
      gsap.to(img, {
        yPercent: -18 * speed,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.5,
          onEnter:     () => { img.style.willChange = 'transform'; },
          onLeave:     () => { img.style.willChange = 'auto'; },
          onEnterBack: () => { img.style.willChange = 'transform'; },
          onLeaveBack: () => { img.style.willChange = 'auto'; },
        },
      });
    });

    // Multi-layer parallax
    gsap.utils.toArray('[data-anim="parallax-layers"]').forEach((el) => {
      el.querySelectorAll('[data-layer]').forEach((layer) => {
        const depth = parseFloat(layer.dataset.layer) || 0.5;
        gsap.to(layer, {
          yPercent: -45 * depth,
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1.5,
            onEnter:     () => { layer.style.willChange = 'transform'; },
            onLeave:     () => { layer.style.willChange = 'auto'; },
            onEnterBack: () => { layer.style.willChange = 'transform'; },
            onLeaveBack: () => { layer.style.willChange = 'auto'; },
          },
        });
      });
    });
  }

  // Hover-video on product cards
  document.querySelectorAll('.hp3-prod-card').forEach(card => {
    const video = card.querySelector('.hp3-prod-card__video');
    if (!video) return;
    card.addEventListener('mouseenter', () => video.play().catch(() => {}));
    card.addEventListener('mouseleave', () => { video.pause(); video.currentTime = 0; });
  });

  // Single deferred refresh — longer delay to let lazy images and app embeds settle
  setTimeout(() => ScrollTrigger.refresh(), 1200);

  // ResizeObserver — debounced, longer timeout, only on significant resize
  let resizeTimer;
  let lastWidth = window.innerWidth;
  new ResizeObserver(() => {
    const newWidth = window.innerWidth;
    if (Math.abs(newWidth - lastWidth) < 50) return;
    lastWidth = newWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 500);
  }).observe(document.body);
});
